import { create } from 'zustand';
import { AccountApi, ApiUtils, ChangeCreditLimitResponse, CreditChangeParams, RequestStrategyEnum } from '@shared/api';

interface IChangeCreditLimitStore {
  loading: boolean;
  error: string | null;
  creditLimit: ChangeCreditLimitResponse | null;
  changeCreditLimit: (searchParams: CreditChangeParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useChangeCreditLimitStore = create<IChangeCreditLimitStore>((set) => ({
  loading: false,
  error: null,
  creditLimit: null,

  changeCreditLimit: ApiUtils.wrapperApi(async (searchParams: CreditChangeParams, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.changeCreditLimit(searchParams, signal);
      set({ creditLimit: result ?? null, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ creditLimit: null, loading: false, error: null }),
}));
